module.exports = __webpack_public_path__ + "static/media/pricelist-background.7595d797.jpg";